import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Collapse } from '@mui/material'
import SummaryMobile from '../components/SummaryMobile'
import * as lib from '../../../../js/lib/lib'
import { useFetcher } from 'react-router-dom'

const SummaryMobilePanel = () => {
  const dictionary =
    window.bookingData?.dictionary || window.modifyData?.dictionary

  const [showSummary, setShowSummary] = useState(false)
  const { selectedVehicle, selectedExtras, isPrepaid } = useSelector(
    (state) => state.booking
  )

  // Handle the mobile summary panel click separately from the form
  const handleSummaryPanelClick = (event) => {
    // Prevent this from affecting the form submission
    event.preventDefault()
    event.stopPropagation()
    setShowSummary(!showSummary)
  }

  const handleContinue = () => {
    setShowSummary(false)
  }

  const computedEstimatedTotal = () => {
    return isPrepaid
      ? selectedVehicle?.car?.prepaidPrice?.estimatedTotal
      : selectedVehicle?.car?.returnPrice?.estimatedTotal
  }

  const computedEstimatedTotalCurrency = () => {
    return isPrepaid
      ? selectedVehicle?.car?.prepaidPrice?.estimatedTotalCurrency
      : selectedVehicle?.car?.returnPrice?.estimatedTotalCurrency
  }
  useEffect(() => {
    if (showSummary) {
      document.documentElement.classList.add('scrollDisabled', 'hide-header')
    } else {
      document.documentElement.classList.remove('scrollDisabled', 'hide-header')
    }

    return () => {
      document.documentElement.classList.remove('scrollDisabled', 'hide-header')
    }
  }, [showSummary])

  return (
    <div
      className={`s-extras-list__summary d-lg-none ${
        showSummary ? 'open' : ''
      }`}>
      {showSummary ? (
        <div className="s-extras-list__summary__panel">
          <div className="s-extras-list__summary__details">
            <span>{dictionary.asideTitle}</span>
          </div>
          <div
            className="s-extras-list__summary__close"
            onClick={handleSummaryPanelClick}>
            <i className="icon-x"></i>
          </div>
        </div>
      ) : (
        <div
          className="s-extras-list__summary__panel"
          onClick={handleSummaryPanelClick}>
          <div className="s-extras-list__summary__arrow">
            <i className="icon-arrow-down"></i>
          </div>
          <div className="s-extras-list__summary__details">
            <span>{selectedVehicle.car.model}</span>
            <div className="s-extras-list__summary__details__price">
              <span>
                {lib.formatCurrency(
                  computedEstimatedTotalCurrency(),
                  computedEstimatedTotal()
                )}
              </span>
              {selectedExtras.length > 0 && (
                <span className="s-extras-list__summary__details__price__extras">
                  +{selectedExtras.length} {dictionary.asideAddedExtrasLabel}
                </span>
              )}
            </div>
          </div>

          <div className="s-extras-list__summary__button">
            <button
              type="submit"
              className="btn btn-outline-primary"
              onClick={(e) => {
                e.stopPropagation()
              }}
              title={dictionary.asideProceedMobileLabel}>
              {dictionary.asideProceedMobileLabel}
            </button>
          </div>
        </div>
      )}
      <Collapse in={showSummary}>
        <SummaryMobile
          showSummary={showSummary}
          handleContinue={handleContinue}
        />
      </Collapse>
    </div>
  )
}

export default SummaryMobilePanel
